(function () {
  function initCarousel(el) {
    // impede inicialização duplicada
    if (el.dataset.carouselInit === '1') {
      return;
    }
    el.dataset.carouselInit = '1';

    const tempo = parseInt(el.dataset.tempo || '0', 10);

    const carousel = new window.bootstrap.Carousel(el, {
      interval: false,
      ride: false,
      pause: false,
      wrap: true
    });

    // se tempo = 0 → não roda
    if (tempo <= 0) {
      return;
    }

    let timer = null;

    function startTimer() {
      stopTimer();
      timer = setInterval(function () {
        carousel.next();
      }, tempo * 1000);
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    startTimer();

    el.addEventListener('mouseenter', stopTimer);
    el.addEventListener('mouseleave', startTimer);
  }

  function init() {
    if (typeof window.bootstrap === 'undefined' || !window.bootstrap.Carousel) {
      setTimeout(init, 100);
      return;
    }

    document.querySelectorAll('.js-home-carousel').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
